// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__lepq3"};